import React, { useState, useEffect } from "react";
import { useParams, useHistory, Link } from "react-router-dom";
import "./Order-history.css";
import "../../assets/css/modal.css";
import { Accordion, Card, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { MyOrders, Reorder } from "../../actions/productActions";
import { orderHistory } from "../../actions/pageAction";
import noorder from "../../assets/images/magnifier.png";
import Pagination from "rc-pagination";

const OrderHistory = (props) => {
  const [load, setLoad] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [orders, setOrders] = useState([]);
  const [orderHistory, setOrderHistory] = useState(null);
  const [aclass, setAclass] = useState(-1);
  const [rorder, setRorder] = useState(-1);
  const { id } = useParams();
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);

  let GetFormattedDate = (date) => {
    var newdate = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
    return newdate;
  }

  let GetFormattedTime = (date) => {
    var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    var minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    var newtime = hour + ':' + minute;
    return newtime;
  }

  useEffect(() => {
    if (
      !props.loading &&
      props.order_history !== null
    ) {
      setOrderHistory(props.order_history);
      setLoaded(true);
    }

    if (!load) {
      props.MyOrders();
      props.orderHistory(page);
      setLoad(true);
    }

    if (props.order_history != null) {
      // RenderCart(props.order_history);
      // RenderOrders();
    }
  }, [history, id, load, loaded, orders, orderHistory, props, rorder]);

  useEffect(() => {
    if (!props.loader) {
      props.orderHistory(page);
    }
  }, [page]);


  let variationRender = (variation) => {
    let html = [];
    if (variation && variation.length > 0) {
      let data = variation;
      Object.keys(data).forEach(function (key) {
        html.push(
          <span key={key} className="text-danger font-weight-bold border border-danger rounded d-flex justify-content-center text-center" style={{ width: "150px" }}>
            {data[key].name}
          </span>);
      });
    }
    return html;
  };

  let RenderCart = (cart) => {
    let html = [];
    if (cart && cart.length > 0) {
      let data = cart;
      Object.keys(data).forEach(function (key) {
        html.push(
          <tr key={key}>
            <td> {data[key].quantity} x</td>
            <td>
              <>
                {" "}
                {data[key] &&
                  data[key].name}{" "}
                {variationRender(data[key].adons)}{" "}
                {
                  data[key]?.combo_products?.length > 0 &&
                  <div className="d-block">
                    <label className="small font-weight-bold">Combo:</label>
                    {data[key].combo_products.map((e, i) => (
                      <div
                        key={i}
                        className="text-danger small font-weight-bold border border-danger rounded text-center mb-2"
                        style={{ width: "150px" }}
                      >
                        {e?.name}
                      </div>
                    ))}
                  </div>
                }
              </>
            </td>
            <td> {parseFloat(data[key].total_for_single_item).toFixed(2)}</td>
          </tr>
        );
      });
    }
    return html;
  };

  const setOrderActive = (index) => {
    console.log("Active orders" + index);
    setAclass(parseInt(index));
  };

  let RenderOrders = () => {
    let html = [];
    if (orderHistory && orderHistory.length > 0) {
      orderHistory.map((key, index) => {
        var inkey = parseInt(key.id);
        var cdate;
        var adate;
        if (key.transaction_date !== null) {
          let t = key.transaction_date?.split(/[- :]/)
          cdate = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5])
        } else {
          cdate = null;
        }

        if (key.d_date !== null) {
          adate = new Date(key.d_date);
        } else {
          adate = null;
        }

        let htmltemp = (
          <Card key={inkey}>
            <Accordion.Toggle
              as={Button}
              onClick={() => setOrderActive(inkey)}
              variant={aclass === inkey ? "danger" : "light"}
              eventKey={inkey}
              style={{ position: "relative" }}
            >
              <span className="invoice-number">
                Invoice Number: {key.invoice_no}
              </span>
              <div className="date-time">
                <span className="date" style={{ marginLeft: '30px' }}>
                  {cdate != null ? GetFormattedDate(cdate) : ""}
                </span>
                <span className="time" style={{ marginLeft: '10px' }}>D
                  {cdate != null ? GetFormattedTime(cdate) : ""}
                </span>
              </div>
              <span
                className="delivery-type"
                style={{
                  position: "absolute",
                  right: "25px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  fontWeight: "600"
                }}
              >
                {key.type_for_api === "Delivery" ? "Delivery" : "Pickup"}
              </span>
              {key.refund_all ? <span className={aclass === inkey ? "void_light" : "void"}> Void </span> : ""}

              <i className="fa fa-caret-down"></i>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey={inkey}>
              <Card.Body>
                <div className="row">
                  <div className="col-md-6">
                    <div className="table-box">
                      <table className="table">
                        <tbody>{RenderCart(key.item)}</tbody>
                        <tfoot>
  {/* Delivery Charge – show only for Delivery & > 0 */}
  {key.type_for_api === "Delivery" &&
    Number(key.delivery_charge) > 0 && (
      <tr>
        <td colSpan="3" style={{ textAlign: "right", paddingRight: "45px" }}>
          <span
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              display: "inline-block",
              marginTop: "4px",
            }}
          >
            Delivery Charge:
          </span>{" "}
          <span
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              display: "inline-block",
              marginTop: "4px",
            }}
          >
            ${Number(key.delivery_charge).toFixed(2)}
          </span>
        </td>
      </tr>
    )}

  {/* Small Order Charge – show only if > 0 */}
  {Number(key.small_order_fee) > 0 && (
    <tr>
      <td colSpan="3" style={{ textAlign: "right", paddingRight: "45px" }}>
        <span
          style={{
            fontWeight: "bold",
            fontSize: "16px",
            display: "inline-block",
            marginTop: "4px",
          }}
        >
          Small Order Charge:
        </span>{" "}
        <span
          style={{
            fontWeight: "bold",
            fontSize: "16px",
            display: "inline-block",
            marginTop: "4px",
          }}
        >
          ${Number(key.small_order_fee).toFixed(2)}
        </span>
      </td>
    </tr>
  )}

  {/* Discount Amount – show only if > 0 */}
  {Number(key.discount_amount) > 0 && (
    <tr>
      <td colSpan="3" style={{ textAlign: "right", paddingRight: "45px" }}>
        <span
          style={{
            fontWeight: "bold",
            fontSize: "16px",
            display: "inline-block",
            marginTop: "4px",
          }}
        >
          Discount Amount:
        </span>{" "}
        <span
          style={{
            fontWeight: "bold",
            fontSize: "16px",
            display: "inline-block",
            marginTop: "4px",
          }}
        >
          ${Number(key.discount_amount).toFixed(2)}
        </span>
      </td>
    </tr>
  )}

  {/* GST – show only if > 0 */}
  {Number(key.tax_amount) > 0 && (
    <tr>
      <td colSpan="3" style={{ textAlign: "right", paddingRight: "45px" }}>
        <span
          style={{
            fontWeight: "bold",
            fontSize: "16px",
            display: "inline-block",
            marginTop: "4px",
          }}
        >
          GST:
        </span>{" "}
        <span
          style={{
            fontWeight: "bold",
            fontSize: "16px",
            display: "inline-block",
            marginTop: "4px",
          }}
        >
          ${Number(key.tax_amount).toFixed(2)}
        </span>
      </td>
    </tr>
  )}
  {Number(key.round_off_amount) > 0 && (
    <tr>
      <td colSpan="3" style={{ textAlign: "right", paddingRight: "45px" }}>
        <span
          style={{
            fontWeight: "bold",
            fontSize: "16px",
            display: "inline-block",
            marginTop: "4px",
          }}
        >
          Round Off:
        </span>{" "}
        <span
          style={{
            fontWeight: "bold",
            fontSize: "16px",
            display: "inline-block",
            marginTop: "4px",
          }}
        >
          -${Number(key.round_off_amount).toFixed(2)}
        </span>
      </td>
    </tr>
  )}
  {/* Total – always show */}
  <tr>
    <td
      colSpan="3"
      style={{
        textAlign: "right",
        paddingTop: "8px",
        borderTop: "1px solid #ddd",
        paddingRight: "45px",
      }}
    >
      <span
        style={{
          fontWeight: "bold",
          fontSize: "16px",
          display: "inline-block",
          marginTop: "4px",
        }}
      >
        Total:
      </span>{" "}
      <span
        style={{
          fontWeight: "bold",
          fontSize: "16px",
          display: "inline-block",
          marginTop: "4px",
        }}
      >
        ${Number(key.total || 0).toFixed(2)}
      </span>
    </td>
  </tr>
</tfoot>

                      </table>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="item-box">
                      <div className="form-group">
                        <label className="control-label">
                          {key.type_for_api === "Delivery"
                            ? " Deliver to"
                            : "Pick up from"}
                        </label>
                        <span className="form-control-static">
                          {key?.type_for_api === "Delivery"
                            ? key?.d_address : key.business_location_name_for_pickup}
                        </span>
                      </div>
                      <div className="form-group">
                        <label className="control-label">
                          Invoice Number
                        </label>
                        <span className="form-control-static">
                          {key?.invoice_no}
                        </span>
                      </div>
                      {key.type_for_api === "Delivery" ? (
                        <>
                          <div className="form-group">
                            <label className="control-label">
                              Estimated Arrival
                            </label>
                            <span className="form-control-static disabled">
                              <span className="date">{key?.estimated_arrival_time?.split(" ")[0]}</span>
                              <span className="time">
                                {key?.estimated_arrival_time?.split(" ")[1]}
                              </span>
                            </span>
                          </div>
                          <div className="form-group">
                            <label className="control-label">
                              Arrived
                            </label>
                            <span className="form-control-static">
                              <span className="date">{key?.updated_at?.split(" ")[0]}</span>
                              <span className="time">
                                {key?.updated_at?.split(" ")[1]}
                              </span>
                            </span>
                          </div>
                        </>
                      ) : (
                        <div className="form-group">
                          <label className="control-label">Pickup time</label>
                          <span className="form-control-static">
                            <span className="date">{adate != null ? GetFormattedDate(adate) : ""}</span>
                            <span className="time">
                              {key.d_time && key.d_time}
                            </span>
                          </span>
                        </div>
                      )}
                      <div className="form-group">
                        <label className="control-label">Payment</label>
                        <span className="form-control-static">
                          {key.paymentType === "cash" || key.paymentType === "paynow" ?
                            <span className="form-control-static">
                              {key.paymentType.toUpperCase()}
                            </span>
                            : <span className="form-control-static">
                              {key.card_type ? key.card_type.toUpperCase() : ""} {key.card_type === "paynow" ? "" : key.last_4_card_digits}
                            </span>
                          }
                        </span>
                      </div>
                      {
                        key.type_for_api === "Delivery"
                          ?
                          <div className="form-group">
                            <label className="control-label">Delivery Status</label>
                            <span className="form-control-static">
                              {key?.lalamove_status}
                            </span>
                          </div>
                          : ""
                      }
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        );
        if (id) {
          if (parseInt(id) === inkey) html.push(htmltemp);
        } else {
          html.push(htmltemp);
        }
      });
    }
    return html;
  };

  return (
    <div className="main_section">
      <div className="order-gutter ispd">
        {orderHistory && orderHistory.length > 0 ? (
          <Accordion defaultActiveKey={orderHistory[0].id}>
            {" "}
            {RenderOrders()}
          </Accordion>
        ) : (
          //When no orders are shown, the footer overlaps and hides the options (Account, Track Order, Order History, Sign Out). Setting the container height to 70vh resolves this issue.
          <div
            className="track_orders"
            style={{
              height: "70vh",
              display: "flex",
              flexDirection: "column", // stack image + text
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <img
              src={noorder}
              alt="No orders"
              style={{ width: "200px", marginBottom: "20px", cursor: "pointer" }}
            />
            <h5 className="text-center">No Order Placed yet</h5>
          </div>
        )}
      </div>
      <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
        <Pagination
          className="custom-pagination"
          current={page}
          total={props.total_orders || 0}
          pageSize={pageSize}
          onChange={(pageNumber) => setPage(pageNumber)}
          showTotal={(total, range) => `Showing ${range[0]}–${range[1]} of ${total}`}
        />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  orders: state.products.orders,
  reorders: state.products.reorders,
  loading: state.products.loading,
  order_history: state.page.order_history,
  total_orders: state.products.total_orders,
  loader: state.products.loader
});

export default withTranslation()(
  connect(mapStateToProps, { MyOrders, Reorder, orderHistory })(OrderHistory)
);
